export const EmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const ValidateEmail = (email: string): boolean => {
    const result = EmailRegex.test(email);
    return result;
};

// export const ShortDateFromFullDateTime = (fulldatetime: string) => dayjs(fulldatetime, 'M/D/YYYY hh:mm:ss A').format('D MMM YYYY');

export default { ValidateEmail, EmailRegex };
